<template>
  <div>
    <div class="floatRight">
      <div class="upload-btn-wrapper">
        <button
          @click="createFileUpload()"
          class="button w-button"
        >{{!$parent.info[slg]?'Browse':'Replace File'}}</button>
        <input id="inputButton" @change="fileUpload($event)" type="file" accept="*" />
      </div>
      <button v-if="$parent.info[slg]" @click="deletefile()" class="red button w-button">Delete File</button>
    </div>
    <div style="text-align:center;" class="obj-field upload-wrapper">
      <input @change="fileUpload($event)" accept="*" fileUpload type="file" value="Upload Files" />

      <a
        v-if="$parent.info[slg]"
        class="text-field w-input"
        :href="$parent.info[slg]?$parent.info[slg].url:'#'"
        target="_blank"
      >
        <img src="../assets/files-and-folders.svg" height="16" />
        {{$parent.info[slg].fileName||fileName}}
      </a>

      <progress v-show="loading"></progress>
      <p v-show="!loading" class="dz-message">Upload Files Here</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileRef",
  props: ["slg", "fname", "index"],
  data() {
    return {
      loading: false,
      fileName: "Pick a file"
    };
  },
  methods: {
    createFileUpload() {
      $("#inputButton").click();
    },
    deletefile() {
      this.$parent.info[this.slg] = null;
    },
    fileUpload(e) {
      if (this.$parent.info[this.slg]) this.deletefile();

      var file = e.target.files[0];
      var storageRef = window.fs.ref(
        `${this.$parent.$parent.set.siteName}/${file.name}`
      );
      var uploader = storageRef.put(file);

      uploader.on(
        "state_changed",
        statusSnapshot => {
          this.loading = true;
        },
        err => {
          alert("error", err);
        },
        () => {
          uploader.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.loading = false;
            this.$parent.info[this.slg] = { url: downloadURL };
            this.fileName = file.name;
          });
        }
      );
    }
  },
  mounted() {
    if (this.$parent.info[this.slg]) {
      var name = decodeURIComponent(
        decodeURIComponent(this.$parent.info[this.slg].url)
      ).split("/");
      this.fileName = name[name.length - 1];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.obj-field.upload-wrapper {
  margin-right: 100px;
}
.red.button.w-button {
  width: 90px;
}
.floatRight {
  float: right;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
}
.button.w-button {
  margin-top: 2px;
}
.upload-btn-wrapper input[type="file"] {
  position: absolute;
}
</style>


